import { Module, VuexModule, Mutation, Action } from "vuex-module-decorators";
import {
  createPartnerService,
  updatePartnerPreferences,
  deletePartner,
  getPartnerPreferences,
  listPartners,
  listTenantPartners,
  fetchPartnerData,
  listChildPartners,
  listPartnersByType,
  listStockPointsByTenant,
  allStockPointTenant,
  listOfficeByPartner,
  changePasswordPartner,
  updatePartnerService,
  getPartnerListLite,
  updatePartnerPaymentPreferences,
  getPartnerPaymentPreferences,
  updatePartnerPaymentConfig,
  getPartnerPaymentConfig,
  getPartnerParentData,
  getSellerProviderConfig,
  listPartnerTypeFilter,
  partnerSearchByNameEmailPhone,
  getPartnerDetailsById,
  getApprovalList,
  updateApprovalRequest,
  getApprovalRequestById,
  fetchPartnerMarketSegment,
  offlinePartner,
  partnerStatusUpdate,
  getAnalyticReport,
  getBulkAnalyticReport,
  getPartnerCustomer,
  createCustomer,
  updateCustomer,
  getBulkCustomerList,
  bulkCustomerImport,
  getStockPointByProvider,
  viewAgentDetails,
  updateUser,
  updateKyc,
  updatePartnerDeliveryPreferences,
  walletList,
} from "@/services/partner";
@Module({
  namespaced: true,
})
export default class Partner extends VuexModule {
  // state
  partnerList = [];
  stockpointList = [];
  allstockpointList = [];
  editPartner = null;
  partnerPreferences = {};
  partnerListLite = [];
  childPartnerList = [];
  getPartnerPaymentConfigSetter = {};
  getPartnerPaymentPreferencesSetter = {};
  getSellerProviderConfig = {};
  getMyParentSetter = {};
  partnerDetailsById = {};
  approvalList = [];
  graphData = {};
  dailyRegistrationGraphData = {};
  orderByTypeGraphData = {};
  partnerCustomerList = [];
  customerbulkreportlist = [];
  agentDetails = [];
  walletData = [];
  chartData = {};

  // actions
  @Action
  public async fetchWalletList(payload) {
    try {
      const response = await walletList(payload);
      this.context.commit("setWalletList", response.data.response);
      return response;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async updateKyc(data) {
    try {
      const res = await updateKyc(data, data.payload);
      return res.data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async updateUser(data) {
    try {
      const res = await updateUser(data._id, data.payload);
      return res.data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async viewAgentDetails(payload) {
    this.context.commit("setAgentDetails", {});
    try {
      const res = await viewAgentDetails(payload.id);
      this.context.commit("setAgentDetails", res.data.response);
      return res.data.data;
    } catch (error) {
      throw error;
    }
  }
  @Action
  public async bulkCustomerImport(payload) {
    try {
      const data = await bulkCustomerImport(payload);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async getBulkCustomerList(payload) {
    try {
      const response = await getBulkCustomerList(payload);
      this.context.commit("setBulkCustomerList", response.data.data);
      return response;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async createCustomer(payload) {
    try {
      const data = await createCustomer(payload);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async updateCustomer(data) {
    try {
      const res = await updateCustomer(data._id, data.payload);
      return res.data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async fetchPartnerCustomerList(payload) {
    try {
      const data = await getPartnerCustomer(payload);
      this.context.commit("setPartnerCustomerList", data.data.response);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async getSellerProviderConfigAction(payload) {
    try {
      const data = await getSellerProviderConfig(payload);
      this.context.commit("getSellerProviderConfigMutation", data.data);
      return data.data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async fetchPartnerDetailsById(payload) {
    try {
      const data = await getPartnerDetailsById(payload);
      this.context.commit("setPartnerDetailsById", data.response);
      return data.response;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async listPartnerTypeFilterAction(payload) {
    try {
      const data = await listPartnerTypeFilter(payload);
      this.context.commit("setPartnerList", data.response);
      return data.data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async listPartnerSearchByNameEmailPhone(payload) {
    try {
      const data = await partnerSearchByNameEmailPhone(payload);
      this.context.commit("setPartnerList", data.response);
      return data.data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async fetchPartnersList() {
    try {
      const data = await listPartners();
      this.context.commit("setPartnerList", data.response);
      return data;
    } catch (error) {
      throw error;
    }
  }
  @Action
  public async fetchTenantPartnersList(payload) {
    try {
      const data = await listTenantPartners(payload);
      this.context.commit("setPartnerList", data.response);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async getMyParentAction(payload) {
    try {
      const data = await getPartnerParentData(payload);
      this.context.commit("setMyParentMutation", data.response);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async getPartnerPaymentConfigAction(payload) {
    try {
      const data = await getPartnerPaymentConfig(payload);
      this.context.commit("getPartnerPaymentConfigMutation", data.data);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async updatePartnerPaymentConfigAction(payload) {
    try {
      const data = await updatePartnerPaymentConfig(payload);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async updatePartnerPaymentPreferencesAction(payload) {
    try {
      const data = await updatePartnerPaymentPreferences(payload);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async updatePartnerdeliveryPreferences(payload) {
    try {
      const data = await updatePartnerDeliveryPreferences(payload);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async getPartnerPaymentPreferencesAction(payload) {
    try {
      const data = await getPartnerPaymentPreferences(payload);
      this.context.commit(
        "getPartnerPaymentPreferencesMutation",
        data.response
      );
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async fetchChildPartnersList(parentId) {
    try {
      const data = await listChildPartners(parentId);
      this.context.commit("setChildPartnerList", data.response);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async fetchPartnerListLite(payload) {
    try {
      const data = await getPartnerListLite(payload);
      this.context.commit("setPartnerListLite", data.response);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async fetchPartnersListByType(payload) {
    try {
      const data = await listPartnersByType(payload);
      this.context.commit("setPartnerList", data.response);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async fetchPartnerMarketSegment() {
    try {
      const data = await fetchPartnerMarketSegment({});
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async updatePartner(payload) {
    try {
      const data = await updatePartnerService(payload.id, payload.data);
      return data;
    } catch (error) {
      throw error;
    }
  }
  @Action
  public async fetchStockpointsByTenant() {
    try {
      const data = await listStockPointsByTenant();
      this.context.commit("setStockPointList", data.response);
      return data;
    } catch (error) {
      throw error;
    }
  }
  @Action
  public async fetchAllStockPointTenant() {
    try {
      const data = await allStockPointTenant();
      this.context.commit("setAllStockPointList", data.response);
      return data;
    } catch (error) {
      throw error;
    }
  }
  @Action
  public async fetchStockpointByProvider(payload) {
    try {
      const data = await getStockPointByProvider(payload);
      this.context.commit("setStockPointList", data.data.response);
      return data.data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public editPartnerData(data) {
    this.context.commit("setEditedPartnerData", {});
    this.context.commit("setEditedPartnerData", data);
  }
  @Action
  public async fetchPartnerDetails(payload) {
    try {
      this.context.commit("setEditedPartnerData", {});
      const data = await fetchPartnerData(payload);
      this.context.commit("setEditedPartnerData", data.response);
    } catch (error) {
      throw error;
    }
  }
  @Action
  public async fetchOfficesByPartner() {
    try {
      const data = await listOfficeByPartner();
      this.context.commit("setPartnerList", data.response);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async createPartner(payload) {
    try {
      const data = await createPartnerService(payload);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async changePasswordPartner(payload) {
    try {
      const data = await changePasswordPartner(payload);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async updatePartnerPreferences(payload) {
    try {
      const data = await updatePartnerPreferences(payload);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async getPartnerPreferences(payload) {
    try {
      const data = await getPartnerPreferences(payload);
      this.context.commit("setPartnerPreference", data.response);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async deletePartner(payload) {
    try {
      const data = await deletePartner(payload);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async getApprovalList(payload) {
    try {
      const data = await getApprovalList(payload);
      this.context.commit("setApprovalList", data.response);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async updateApprovalRequest(payload) {
    try {
      const data = await updateApprovalRequest(payload);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async getApprovalRequestById(payload) {
    try {
      const data = await getApprovalRequestById(payload);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async offlinePartner(payload) {
    try {
      const data = await offlinePartner(payload.id, payload.data);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async partnerStatusUpdate(payload) {
    try {
      const data = await partnerStatusUpdate(payload.id, payload.data);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async fetchAnalyticReport(payload) {
    try {
      if (Array.isArray(payload)) {
        const responseData = {};
        const allData = payload.map(async x => {
          const res = await getAnalyticReport(x.payload);
          responseData[x.key] = res.data.response;
          return;
        });
        await Promise.all(allData);
        return responseData;
      }
      const data = await getAnalyticReport(payload);
      return data.data.response;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async fetchBulkAnalyticReport(payload) {
    try {
      let responseData = {};
      const res = await getBulkAnalyticReport(payload);
      this.context.commit("setDailyRegistrationChart", res.data.data);
      return res.data.data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async fetchOrderByTypeChartReport(payload) {
    try {
      const res = await getBulkAnalyticReport(payload);
      this.context.commit("setOrderByTypeChart", res.data.data);
      return res.data.data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async fetchBulkChart(payload) {
    try {
      let responseData = {};
      const res = await getBulkAnalyticReport(payload);
      this.context.commit("setDashboardChart", res.data.data);
      return res.data.data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async fetchChart(payload) {
    try {
      let responseData = {};
      const res = await getBulkAnalyticReport(payload);
      this.context.commit("setChart", res.data.data);
      return res.data.data;
    } catch (error) {
      throw error;
    }
  }

  // mutations
  @Mutation
  public setWalletList(data) {
    this.walletData = data;
  }

  @Mutation
  public setAgentDetails(data: any) {
    this.agentDetails = data;
  }

  @Mutation
  public setBulkCustomerList(data) {
    this.customerbulkreportlist = data;
  }

  @Mutation
  public setPartnerCustomerList(data: any) {
    this.partnerCustomerList = data;
  }

  @Mutation
  public setDashboardChart(data: any) {
    this.graphData = data;
  }

  @Mutation
  public setDailyRegistrationChart(data: any) {
    this.dailyRegistrationGraphData = data;
  }

  @Mutation
  public setOrderByTypeChart(data: any) {
    this.orderByTypeGraphData = data;
  }

  @Mutation
  public setChart(data: any) {
    this.chartData = data;
  }

  @Mutation
  public setApprovalList(data: any) {
    this.approvalList = data;
  }

  @Mutation
  public setPartnerList(data: any) {
    this.partnerList = data;
  }

  @Mutation
  public getPartnerPaymentPreferencesMutation(data: any) {
    this.getPartnerPaymentPreferencesSetter = data;
  }

  @Mutation
  public getPartnerPaymentConfigMutation(data: any) {
    this.getPartnerPaymentConfigSetter = data;
  }

  @Mutation
  public setChildPartnerList(data: any) {
    this.partnerList = data;
  }

  @Mutation
  public setPartnerListLite(data: any) {
    this.partnerListLite = data;
  }

  @Mutation
  public setStockPointList(data: any) {
    this.stockpointList = data;
  }
  @Mutation
  public setAllStockPointList(data: any) {
    this.allstockpointList = data;
  }

  @Mutation
  public setEditedPartnerData(data: any) {
    this.editPartner = data;
  }
  @Mutation
  public setPartnerPreference(data: any) {
    this.partnerPreferences = data;
  }

  @Mutation
  public setMyParentMutation(data: any) {
    this.getMyParentSetter = data;
  }

  @Mutation
  public getSellerProviderConfigMutation(data: any) {
    this.getSellerProviderConfig = data;
  }

  @Mutation
  public setPartnerDetailsById(data: any) {
    this.partnerDetailsById = data;
  }

  // getters

  get GetSellerProviderConfigGatter() {
    return this.getSellerProviderConfig;
  }

  get GetPartnerList() {
    return this.partnerList;
  }

  get GetChildPartnerList() {
    return this.childPartnerList;
  }

  get GetPartnerLiteList() {
    return this.partnerListLite;
  }

  get GetStockPointList() {
    return this.stockpointList;
  }

  get GetAllStockPointList() {
    return this.allstockpointList;
  }

  get GetPartnerData() {
    return this.editPartner;
  }
  get GetPartnerPreferences() {
    return this.partnerPreferences;
  }

  get GetPartnerPaymentConfig() {
    return this.getPartnerPaymentConfigSetter;
  }

  get getPartnerPaymentPreferencesGetter() {
    return this.getPartnerPaymentPreferencesSetter;
  }

  get getMyParentGatter() {
    return this.getMyParentSetter;
  }

  get GetPartnerDetailsById() {
    return this.partnerDetailsById;
  }
  get GetApprovalsList() {
    return this.approvalList;
  }
  get getBulkAnalyticsReport() {
    return this.graphData;
  }
  get GetBulkAnalyticsRept() {
    return this.dailyRegistrationGraphData;
  }
  get GetOrderByTypeReport() {
    return this.orderByTypeGraphData;
  }
  get GetPartnerCustomerList() {
    return this.partnerCustomerList;
  }
  get GetBulkCustomerList() {
    return this.customerbulkreportlist;
  }
  get GetAgentDetails() {
    return this.agentDetails;
  }
  get GetWalletData() {
    return this.walletData;
  }
  get getChartData() {
    return this.chartData;
  }
}
